import { NumberFilterConfig } from '../types/filter-config';
import { defaultFilterInputTypeFactory } from '../page-filter/helper/default-filter-input-type.factory';
import { FilterItemConfigOptions } from '../types/filter-item-config-options';
import { Type } from '@angular/core';
import { FilterStateFactoryRef } from './filter.function';
import { NumberFilter } from '../types/filter';
import { QueryFilter } from '@softline/core';
import { NumberFilterOperator } from '../types/filter-operators';

export interface NumberFilterOptions<T extends object> extends FilterItemConfigOptions<T, number> {
  componentFactory?: (type: 'number', operator: NumberFilterOperator) => Type<any>;
  defaultOperator?: NumberFilterOperator;
  allowedOperators?: NumberFilterOperator[];
}

export function numberFilter<T extends object>(
  ref: FilterStateFactoryRef<T>,
  options: NumberFilterOptions<T>): void {
  ref.addItem({
    ...options,
    type: 'number',
    defaultOperator: options.defaultOperator ?? 'equals',
    allowedOperators: options.allowedOperators ?? ['equals', 'notEquals', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual', 'in', 'notIn', 'between'],
    inputTypeFactory: defaultFilterInputTypeFactory,
    formatter: options.formatter ?? ((o) => `${o}`),
    toQueryFilter
  });
}

function toQueryFilter<T extends object>(value: NumberFilter<T>): QueryFilter<T> {
  switch (value.operator) {
    case 'empty':
      return { name: value.field, type: 'numberEmpty' }
    case 'notEmpty':
      return { name: value.field, type: 'numberNotEmpty' }
    case 'equals':
      return { name: value.field, type: 'numberEquals', value: value.value}
    case 'notEquals':
      return { name: value.field, type: 'numberNotEquals', value: value.value}
    case 'greaterThan':
      return { name: value.field, type: 'numberGreaterThan', value: value.value}
    case 'greaterThanOrEqual':
      return { name: value.field, type: 'numberGreaterThanOrEquals', value: value.value}
    case 'lessThan':
      return { name: value.field, type: 'numberLessThan', value: value.value}
    case 'lessThanOrEqual':
      return { name: value.field, type: 'numberLessThanOrEquals', value: value.value}
    case 'between':
      return { name: value.field, type: 'numberInRange', valueFrom: value.value.from, valueTo: value.value.to }
    case 'in':
      return { name: value.field, type: 'numberSet', values: value.value}
    case 'notIn':
      throw new Error('operator notIn not supported yet by the api');
  }
}
